import { EBiologicalSex, EPatientsColor, IPatient } from '~/interfaces'
import { getAgeByBirthDate } from '~/utils'

export const getBiologicalSexOf = (patient: IPatient): string => {
  const isPatientFemale = patient.biologicalSex === EBiologicalSex.FEMALE
  return (isPatientFemale ? 'FEMALE' : 'MALE').toLowerCase()
}

export const getSkinColorOf = (patient: IPatient): string => {
  const patientSkinColor = patient.color === EPatientsColor.BLACK ? EPatientsColor.BLACK : EPatientsColor.WHITE
  return EPatientsColor[patientSkinColor].toLowerCase()
}

type getImageBodyRepresentationOfReturn = (
  ethnicalGroupImages: IEthnicalGroupImages
) => React.FC<React.SVGProps<SVGSVGElement>>

interface IEthnicalGroupImages {
  adult: React.FC<React.SVGProps<SVGSVGElement>>
  gradescholler: React.FC<React.SVGProps<SVGSVGElement>>
  infant: React.FC<React.SVGProps<SVGSVGElement>>
  old: React.FC<React.SVGProps<SVGSVGElement>>
  prenatal: React.FC<React.SVGProps<SVGSVGElement>>
  preschool: React.FC<React.SVGProps<SVGSVGElement>>
  teen: React.FC<React.SVGProps<SVGSVGElement>>
}

export const getImageBodyRepresentationOf =
  (patient: IPatient): getImageBodyRepresentationOfReturn =>
  (ethnicalGroupImages: IEthnicalGroupImages): React.FC<React.SVGProps<SVGSVGElement>> => {
    const millisecondsOfLife = new Date().getTime() - new Date(patient.birthDate).getTime()
    const daysOfLife = Math.ceil(millisecondsOfLife / 1000 / 60 / 60 / 24)
    const yearsOfLife = getAgeByBirthDate(patient.birthDate) as number

    if (daysOfLife <= 28) return ethnicalGroupImages.prenatal
    if (yearsOfLife <= 2) return ethnicalGroupImages.infant
    if (yearsOfLife <= 6) return ethnicalGroupImages.preschool
    if (yearsOfLife <= 12) return ethnicalGroupImages.gradescholler
    if (yearsOfLife <= 19) return ethnicalGroupImages.teen
    if (yearsOfLife <= 59) return ethnicalGroupImages.adult
    if (yearsOfLife > 60) return ethnicalGroupImages.old

    return ethnicalGroupImages.adult

    // // TODO: is this the best approach?
    // const periodsOfLife = {
    //   prenatal: daysOfLife <= 28,
    //   infant: yearsOfLife <= 2 && daysOfLife > 28,
    //   preschool: yearsOfLife <= 6 && yearsOfLife > 2,
    //   gradescholler: yearsOfLife <= 12 && yearsOfLife > 6,
    //   teen: yearsOfLife <= 19 && yearsOfLife > 12,
    //   adult: yearsOfLife <= 59 && yearsOfLife > 19,
    //   old: yearsOfLife > 60
    // }

    // const periodOfLife = Object.keys(periodsOfLife).find(period => periodsOfLife[period])
    // return ethnicalGroupImages[periodOfLife ?? 'adult']
  }
